import { useState } from "react";
import { setDatasets } from "react-chartjs-2/dist/utils";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import {
  Heading,
  TableContainer,
  TableDetails,
  TableRootContainer,
  PaginationNext,
  PaginationPrev,
  PaginationButtonsContainer,
  PaginationContainer,
} from "./Styles";
import TableHead from "./TableHead";
import TableRow from "./TableRow";
import EmptyState from "shared/components/EmptyState";
// import consoleLog from "shared/utils/consoleLog";

interface Props{
  headData: any;
  bodyData?: any;
  hoverLink?: any
  clickFunction?: any;
  rowStyle?: any;
  serialNumber?: boolean;
  currentpage?: number;
  numberOfItems?: number;
  totalPages?: number;
  goToPage?: any;
  emptyStateMessage?: string;
}
const Table = ({
  headData,
  bodyData,
  hoverLink,
  clickFunction,
  serialNumber,
  currentpage = 1,
  totalPages = 0,
  numberOfItems = 10,
  goToPage,
  emptyStateMessage="No data to display"
}: Props) => {


  if (typeof currentpage === "string") {
    currentpage = Number(currentpage);
  }

  return (
    <>
      <TableRootContainer>
        <TableContainer>
          <thead>
            <Heading>
              <TableHead key="sn" item="#" />
              {headData.map((data: any) => {
                return (
                  <TableHead
                    key={data.id}
                    item={data.label}

                    // onClick={() => sorting(data.id)}
                  />
                );
              })}
            </Heading>
          </thead>
          {bodyData && bodyData instanceof Array && bodyData.length ? (
            <TableDetails>
              {bodyData.map((data: any, index: number) => {
                return (
                  <TableRow
                    serialNumber={serialNumber}
                    index={index}
                    key={`${index}}a`}
                    data={data}
                    headData={headData}
                    hoverLink={hoverLink}
                    clickFunction={clickFunction}
                  />
                );
              })}
            </TableDetails>
          ):(
            <TableDetails>
              <tr>
                <td colSpan={headData.length + 1} style={{textAlign: "center"}}>
                  <EmptyState stateTitle={emptyStateMessage} />
                </td>
              </tr>
                
            </TableDetails>
          )}
          
          
        </TableContainer>
      </TableRootContainer>
      {bodyData instanceof Array && bodyData.length > 0 && totalPages > 1 && (
        <PaginationContainer>
          <div></div>

          <PaginationButtonsContainer>
            {currentpage > 1 && (
              <PaginationPrev
                onClick={() => goToPage && goToPage(currentpage - 1)}
              >
                {"< "}Prev
              </PaginationPrev>
            )}
            <div>
              {currentpage} of {totalPages} pages
            </div>
            {totalPages > 1 && (
              <>
                {currentpage < totalPages && (
                  <PaginationNext
                    onClick={() => goToPage && goToPage(currentpage + 1)}
                  >
                    Next {` >`}
                  </PaginationNext>
                )}
              </>
            )}
          </PaginationButtonsContainer>
        </PaginationContainer>
      )}
    </>
  );
};

export default Table;
